import { render, staticRenderFns } from "./predictTheOutcomeModules.vue?vue&type=template&id=6900c073&scoped=true&"
import script from "./predictTheOutcomeModules.vue?vue&type=script&lang=js&"
export * from "./predictTheOutcomeModules.vue?vue&type=script&lang=js&"
import style0 from "./predictTheOutcomeModules.vue?vue&type=style&index=0&id=6900c073&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6900c073",
  null
  
)

export default component.exports